
import {createStore} from "vuex";
import axios from "axios";

let initialContent = {
    home_banner: '',
    home_intro: '',
    footer_copy: '',
};

if (window && window.content) {
    initialContent = window.content;
}

const initialState = () => ({
    initialized: false,
    authenticated: false,
    user: null,
    intended: null,
    content: initialContent,
})

export default createStore({

    state: initialState,

    getters: {
        initialized(state) {
            return state.initialized
        },
        authenticated(state) {
            return state.authenticated
        },
        user(state) {
            return state.user
        },
        intended(state) {
            return state.intended
        },
        roles(state) {
            if (state.user) {
                return state.user.roles.map(item => item.name);
            }

            return [];
        },
        isAdmin(state, getters) {
            return getters.roles.indexOf('admin') >= 0;
        },
        isTrainer(state, getters) {
            return getters.roles.indexOf('trainer') >= 0;
        },
        isModerator(state, getters) {
            return getters.roles.indexOf('moderator') >= 0;
        },
        isStudent(state, getters) {
            return getters.roles.indexOf('student') >= 0;
        },
        content(state) {
            return state.content;
        }
    },

    mutations: {
        INITIALIZE(state) {
            state.initialized = true;
        },
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value
        },
        SET_USER(state, value) {
            state.user = value
        },
        SET_INTENDED(state, value) {
            state.intended = value
        },
        RESET(state) {
            Object.assign(state, initialState())
        },
        SET_CONTENT(state, content) {
            state.content = Object.assign(initialContent, content);
        },
    },

    actions: {
        async logout({dispatch}) {
            await axios.post(route('logout'));
            await dispatch('clearUser');
        },
        async fetchUser({commit, dispatch}) {

            try {
                const user = (await axios.get(route('auth.user'))).data;
                commit('SET_AUTHENTICATED', true);
                commit('SET_USER', user);
            } catch (e) {
                dispatch('clearUser');
            }

            commit('INITIALIZE');

            return true;
        },
        async deauthenticate({commit}) {
            commit('SET_AUTHENTICATED', false)
        },
        async clearUser({commit}) {
            commit('SET_AUTHENTICATED', false)
            commit('SET_USER', null)
        },
        async reset({commit}) {
            commit('RESET');
        },
        async fetchContent({commit}) {
            try {
                commit('SET_CONTENT', (await axios.get(route('api.settings.content'))).data);
            } catch (e) {
                console.warn(e);
            }
        },
    }
});
